import { Component, OnInit } from '@angular/core';
import { HistoryService } from 'src/app/shared/services/history.service';
import { ActivatedRoute } from '@angular/router';

declare  var jQuery:  any;
declare  var $:  any;

@Component({
  selector: 'app-history-single',
  templateUrl: './history-single.component.html',
  styleUrls: ['./history-single.component.scss']
})
export class HistorySingleComponent implements OnInit {
   
   historyList: any = "";
   historySingle: any = {};
   historyRequest: any = {};

   slidegalleryConfig = {
		  //dots: true,
		  infinite: true,
		  arrows:true,
		  slidesToShow:2,
		  autoplay:false,
		  speed: 500,
		responsive: [{
		       
		      breakpoint: 1024,  
		      settings: {
		        slidesToShow: 2
		      }
		      },  
		      {
		      breakpoint: 992,  
		      settings: {
		        slidesToShow: 2
		      }
		      },
		      {
		      breakpoint: 767,  
		      settings: {
		        slidesToShow: 1
		      }

		    }]
		}; 
  constructor(
  	private historyService: HistoryService,
  	private activatedRoute:ActivatedRoute,
  	) { }

  ngOnInit() {
  	this.historyService.getHistory().then((data) => {this.historyList = data });

    this.activatedRoute.params.subscribe((data)=>{
      if(data.slug){
        this.getHistory(data.slug);
        //this.newsRequest = data.slug;
      }
    });
  }

  getHistory(historyslug) {
    this.historyRequest.slug = historyslug;
    let request = Object.assign({}, this.historyRequest)
    this.historyService.getSinglehistory(request).then((data) => {
       this.historySingle = data.data || {};
       
       console.log(this.historySingle);
       
      
      });
  }

}
